import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, Alert } from 'reactstrap';
import Editor from '../Editor';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux'
import { CircularProgress } from '@mui/material';
import EmailSubject from '../EmailSubject';
import { TemplateSaveMultiplePopoverItem } from '../popovers/TemplateSaveMultiplePopoverItem';

class TemplateEditorModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            resources: [],
            folders: [],
            selectedFolder: '',
            html: '',
            rawHtml: '',
            subject: '',
            isLoading: true,
            reportFields: [],
            showtext: true,
            templates: [],
            selectTemplateIndex: 0,
            saveError: false,
            fieldsLoaded: false,
            errorMessage: '',
            saveMessage: '',
            admin_email: '',
            saving: false,
            useDefault: true,
            saveMultiple: [],
            saveMultipleModalVisible: false,
            savePopoverTarget: null,
            distributionReports: false,
            sendReportsOnCompletion: false,
            ...props
        }
    }

    useDefaultCheckChange = (e) => {
        const target = e.target;
        const value = target.checked;
        this.setState({
            useDefault: value
        });
    }

    downloadDocumentTypeConfigFields = (value) => {
        fetch("/api/configuration/get_report_fields?report_code=" + value + "&folder=" + this.props.file.folder)
            .then(res => res.json())
            .then(result => {
                let customDescriptions = [];

                if (result) {
                    result.forEach(reportField => {
                        var a = `
                    
                    .ql-picker.ql-insertCustomTags [data-value="@model.DocumentData.` + reportField.Name + `"]::before {
                        content: "` + reportField.Description.en + `"} 
                        
                        
                        `;

                        customDescriptions.push(a);
                    })
                }

                this.setState({
                    reportFields: result,
                    customDescriptions: customDescriptions,
                    isLoading: false,
                    fieldsLoaded: true
                })
            })
    }

    componentDidMount = () => {
        if (this.props.useFilteredTemplates) {
            this.setState({
                subject: this.props.templates[0].subject,
                templates: this.props.templates,
                useDefault: this.props.file.use_default,
                distributionReports: this.props.file.distribution_report,
                sendReportsOnCompletion: this.props.file.send_report_on_process_complete
            });
        }
        else {
            this.setState({
                subject: this.props.file.subject,
                admin_email: this.props.file.admin_email,
                html: this.props.file.html,
                rawhtml: this.props.file.html,
                useDefault: this.props.file.use_default,
                distributionReports: this.props.file.distribution_report,
                sendReportsOnCompletion: this.props.file.send_report_on_process_complete
            })
        }
        if (!this.props.edit) {
            this.getX3Folders()
        }

        if (this.props.file.template)
            this.downloadDocumentTypeConfigFields(this.props.file.template);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.file != this.props.file)
            this.setState({
                subject: this.props.file.subject,
                html: this.props.file.html,
                rawhtml: this.props.file.html,
                admin_email: this.props.file.admin_email,
                useDefault: this.props.file.use_default
            })

        if (this.props.edit != prevProps.edit && !this.props.edit) {
            this.formIsLoading();
            this.getX3Folders();
        }


        if (this.state.selectedFolder != prevState.selectedFolder) {
            this.formIsLoading();
            this.getX3FolderLanguages();
            this.getX3ReportTypes();
        }

        //if(this.state.selectedLanguage != prevState.selectedLanguage)
        //  this.getX3ReportTypes ();
    }

    formIsLoading = () => {
        this.setState({
            isLoading: true
        });
    }

    trySaveTemplate = (e) => {
        if (this.state.saveMultiple.length > 1) {
            this.setState({
                savePopoverTarget: e.currentTarget,
                saveMultipleModalVisible: true
            })
        } else {
            this.saveTemplate(false);
        }
    }

    saveTemplate = (save_all) => {
        this.setState({
            saving: true,
            saveError: false,
            errorMessage: '',
        })

        // remove legacy editorhtml and rawhtml items
        let template = null;
        let id = 0;
        let save_multiple = false;

        if (save_all && this.state.saveMultiple.length > 0) {
            // if save all is selected then iterrate though changed templates and save them
            save_multiple = true;
            template = [];
            id = [];
            for (let i of this.state.saveMultiple) {
                let temp = { ...this.state.templates[i] };
                temp.editorHtml = null;
                temp.rawHtml = null;
                template.push(temp);
                id.push(i);
            }
        } else {
            template = { ...this.state.templates[this.state.selectTemplateIndex] };
            template.editorHtml = null;
            template.rawHtml = null;
            id = this.state.selectTemplateIndex;
        }

        if (this.props.edit && !this.props.newVersion) {
            fetch(window.location.protocol + '//' + window.location.host + "/api/email/save_email_template",
                {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        file: this.props.file,
                        subject: this.state.subject,
                        template: template,
                        templateIndex: id,
                        admin_email: this.state.admin_email,
                        use_default: this.state.useDefault,
                        distribution_report: this.state.distributionReports,
                        send_on_completion: this.state.sendReportsOnCompletion,
                        save_multiple
                    })
                })
                .then(res => {
                    if (res.ok && res.status == 200)
                        return res.json()
                    else if (res.status == 413)
                        throw Error("Template size too large, please remove or compress any large images and retry ...")
                    else
                        throw Error("Template save error:" + res.statusText)
                })
                .then(result => {
                    this.props.alert.success("Templates saved");
                    this.props.toggle();
                    // this.setState({
                    //     saving: false,
                    //     saveMessage: "All Templates Saved",
                    // })
                })
                .catch(error => {
                    this.setState({
                        saveError: true,
                        errorMessage: error,
                        saving: false
                    })
                })
        }
        else if (this.props.edit && this.props.newVersion) {
            fetch(window.location.protocol + '//' + window.location.host + "/api/email/create_new_version_of_template", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    _id: this.props.file.parentId ? this.props.file.parentId : this.props.file._id,
                    templates: this.state.templates,
                    use_default: this.state.useDefault
                })
            })
                .then(res => {
                    if (res.ok && res.status == 200)
                        return res.json()
                    else if (res.status == 413)
                        throw Error("Template size too large, please remove or compress any large images and retry ...")
                    else
                        throw Error("Template save error:" + res.statusText)
                })
                .then(result => {
                    this.props.alert.success(result.message);
                    this.props.toggle();
                })
                .catch(error => {
                    this.setState({
                        saveError: true,
                        errorMessage: error,
                        saving: false
                    })
                })
        }
        else {
            fetch(window.location.protocol + '//' + window.location.host + "/api/email/create_new_template", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    template: this.state.type,
                    folder: this.state.selectedFolder,
                    subject: this.state.subject,
                    language: this.state.selectedLanguage,
                    admin_email: this.state.admin_email,
                    templates: this.state.templates,
                    use_default: this.state.useDefault,
                    distribution_report: this.state.distributionReports,
                    send_on_completion: this.state.sendReportsOnCompletion
                })
            })
                .then(res => {
                    if (res.ok && res.status == 200)
                        return res.json()
                    else if (res.status == 413)
                        throw Error("Template size too large, please remove or compress any large images and retry ...")
                    else
                        throw Error("Template save error:" + res.statusText)
                })
                .then(result => {
                    this.setState({
                        saving: false,
                        saveMessage: result.message
                    })
                })
                .catch(error => {
                    this.setState({
                        saveError: true,
                        errorMessage: error,
                        saving: false
                    })
                })
        }
    }

    deleteTemplate = (i) => {
        fetch(window.location.protocol + '//' + window.location.host + "/api/email/remove_email_template_filter", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                _id: this.props.file.parentId ? this.props.file.parentId : this.props.file._id,
                index: i
            })
        })
            .then(res => {
                if (res.ok && res.status == 200)
                    return res.json()
                else
                    throw Error("Template delete error:" + res.statusText)
            })
            .then(result => {
                this.setState({
                    saving: false,
                    saveMessage: result.message
                })
            })
            .catch(error => {
                this.setState({
                    saveError: true,
                    errorMessage: error,
                    saving: false
                })
            })
    }

    getX3Folders = () => {
        fetch(window.location.protocol + '//' + window.location.host + "/api/sageX3/get_x3_folders")
            .then(res => res.json())
            .then(result => {
                this.setState({
                    folders: result.$resources,
                    isLoading: false
                })
            })
    }

    getX3FolderLanguages = () => {
        fetch(window.location.protocol + '//' + window.location.host + "/api/sageX3/get_folder_languages?folder=" + this.state.selectedFolder)
            .then(res => res.json())
            .then(result => {
                this.setState({
                    languages: result.ADSALAN,
                    //isLoading: false
                })
            })
    }

    getX3ReportTypes = () => {
        // fetch(window.location.protocol + '//' + window.location.host + "sageX3?folder=" + this.state.selectedFolder)
        fetch("/api/configuration/documentTypes?folder=" + this.state.selectedFolder + "&DocumentArea=x3")
            .then(res => res.json())
            .then(result => {
                this.setState({
                    resources: result.$resources,
                    isLoading: false
                })
            })
    }

    handleFilterChange = (templates, selectTemplateIndex) => {
        let stateTemplate = this.state.templates[selectTemplateIndex];
        let template = templates[selectTemplateIndex];
        let saving = [...this.state.saveMultiple];

        if (JSON.stringify(stateTemplate) !== JSON.stringify(template)) {
            if (!saving.includes(selectTemplateIndex))
                saving.push(selectTemplateIndex);
        }

        this.setState({
            subject: templates[selectTemplateIndex].subject,
            admin_email: templates[selectTemplateIndex].admin_email,
            templates: templates,
            selectTemplateIndex: selectTemplateIndex,
            saveMultiple: saving
        });
    }

    handleSubjectChange = (value, filtered) => {
        if (!filtered)
            this.setState({ subject: value })
        else {
            let templates = [...this.state.templates];
            templates[this.state.selectTemplateIndex].subject = value;

            this.setState({
                subject: value,
                templates: templates
            });
        }
    }

    handleAdminEmailChange = (value, filtered) => {
        if (!filtered)
            this.setState({ admin_email: value })
        else {
            let templates = [...this.state.templates];
            templates[this.state.selectTemplateIndex].admin_email = value;

            this.setState({
                admin_email: value,
                templates: templates
            });
        }
    }


    handleInputChange = (html) => {
        this.setState({
            html: html
        })
    }

    handleRawInputChange = (html) => {
        this.setState({
            rawhtml: html
        })
    }

    handleDropdownChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    render() {

        const { localisation } = this.props.userReducer;

        let folders = []
        let languages = []
        let resources = []
        let loading = <div />
        let alert = <div />;
        let info_alert = <div />;

        if (this.state.folders)
            this.state.folders.forEach(res => {
                folders.push(<option>{res.DOSSIER}</option>)
            });
        if (this.state.languages)
            this.state.languages.forEach(res => {
                languages.push(<option value={res.LAN}>{res.$title}</option>)
            });
        if (this.state.resources)
            this.state.resources.forEach(res => {
                resources.push(<option>{res.RPTEVT}</option>)
            });

        if (this.state.isLoading)
            loading = <Progress animated color="info" value={100} />

        if (this.state.saveError && this.state.errorMessage)
            alert = <Alert style={{ marginTop: '10px' }} color="danger">{'Template save error: ' + this.state.errorMessage}</Alert>

        if (this.state.saveMessage)
            info_alert = <Alert style={{ marginTop: '10px' }} color="success">{this.state.saveMessage}</Alert>

        return (
            <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog' backdrop={'static'}>
                <ModalHeader toggle={this.props.toggle}>{this.props.newVersion ?
                    (localisation['modal_new_version'] ? localisation['modal_new_version'].element_lang : 'New Version' + ':' + this.props.file.template)
                    :
                    (localisation['modal_edit'] ? localisation['modal_edit'].element_lang + ":" + this.props.file.template : "Edit:" + this.props.file.template) +
                    (localisation['modal_version'] ? " " + localisation['modal_version'].element_lang + ":" + this.props.file.version : " Version:" + this.props.file.version)}
                </ModalHeader>
                <ModalBody>
                    <Row form>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="selectedFolder" className="s-field-title s-anchored">{localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : ''}</Label>
                                {!this.props.edit ? (
                                    <Input type="select" name={"selectedFolder"} onChange={this.handleDropdownChange} id={"selectedFolder"}>
                                        {folders}
                                    </Input>) : (
                                    <Input type="text" value={this.props.file.folder} disabled />
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="selectedLanguage" className="s-field-title s-anchored">{localisation['table_header_language'] ? localisation['table_header_language'].element_lang : ''}</Label>
                                {!this.props.edit ? (
                                    <Input type="select" name={"selectedLanguage"} onChange={this.handleDropdownChange} id={"selectedLanguage"}>
                                        {languages}
                                    </Input>) : (
                                    <Input type="text" value={this.props.file.language} disabled />
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="type" className="s-field-title s-anchored">{localisation['table_header_code'] ? localisation['table_header_code'].element_lang : ''}</Label>
                                {!this.props.edit ? (
                                    <Input type="select" name={"type"} onChange={this.handleDropdownChange} id={"type"}>
                                        {resources}
                                    </Input>) : (
                                    <Input type="text" value={this.props.file.template} disabled />
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    {loading}
                    {this.state.fieldsLoaded &&
                        <>
                            <EmailSubject
                                options={this.state.reportFields}
                                subject={this.state.templates[this.state.selectTemplateIndex].subject}
                                setSubject={this.handleSubjectChange}
                                filterTemplates={true}
                            />
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label for="admin_email" className="s-field-title s-anchored">Admin Email</Label>
                                        <Input
                                            type="text"
                                            value={this.state.admin_email}
                                            name="admin_email"
                                            onChange={(e) => this.handleAdminEmailChange(e.target.value, true)}
                                        />
                                    </FormGroup>
                                    <FormGroup check>
                                        <Row>
                                            <Col md={5}>
                                                <Label for="useDefault" className="s-field-title s-anchored">
                                                    <Input type="checkbox" name={'useDefault'} checked={this.state.distributionReports} onClick={() => this.setState({ distributionReports: !this.state.distributionReports })} />{' '}
                                                    Send Distribution Report
                                                </Label>
                                            </Col>
                                            <Col md={5}>
                                                <Label for="useDefault" className="s-field-title s-anchored">
                                                    <Input type="checkbox" name={'useDefault'} checked={this.state.sendReportsOnCompletion} onClick={() => this.setState({ sendReportsOnCompletion: !this.state.sendReportsOnCompletion })} />{' '}
                                                    Only send report on process error
                                                </Label>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup check style={{ marginTop: '25px' }}>
                                        <Label for="useDefault" className="s-field-title s-anchored">
                                            <Input type="checkbox" name={'useDefault'} checked={this.state.useDefault} onClick={this.useDefaultCheckChange} />{' '}
                                            Use Default
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Editor
                                placeholder={localisation['email_text_placeholder'] ? localisation['email_text_placeholder'].element_lang : ''}
                                filteredTemplates={this.state.templates}
                                activateHtmlButton={this.activateHtmlButton}
                                reportFields={this.state.reportFields}
                                customDescriptions={this.state.customDescriptions}
                                updateTemplates={this.handleFilterChange}
                                deleteTemplate={this.deleteTemplate}
                            />
                        </>
                    }
                    {alert}
                    {info_alert}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.trySaveTemplate} disabled={this.state.saving}>
                        {this.state.saving ?
                            <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
                            :
                            localisation['save_button'] ? localisation['save_button'].element_lang : 'Save'
                        }
                    </Button>
                    <Button color="secondary" onClick={this.props.toggle}>{localisation['close_button'] ? localisation['close_button'].element_lang : 'Close'}</Button>
                </ModalFooter>
                {this.state.saveMultipleModalVisible &&
                    <TemplateSaveMultiplePopoverItem
                        popoverURLAncor={this.state.savePopoverTarget}
                        handleSaveAll={() => this.saveTemplate(true)}
                        handleSaveOne={() => this.saveTemplate(false)}
                        toggle={this.toggleSavePopover}
                    />
                }
            </Modal>
        );
    }
}

export default connect(state => state)(withAlert()(TemplateEditorModal));



